import * as z from "zod";

export const deleteSenderEmail = {
  name: "deleteSenderEmail" as const,
  input: z.object({ email: z.string().email() }),
  output: z.object({ success: z.boolean() }),
};
